import style from "./productCardV2.module.css";
import {
    iconCartV2,
    iconMiniCartButton,
    typeClinicalAnalysis,
    typeVaccine,
    typeVaccineCombo
} from "../../assets";
import {Link} from "preact-router/match";
import {useAppContext, useBehavioralContext} from "../../contexts";
import {getServiceBadgeColor} from "../../utils";

const ProductCardV2 = props => {
    // Destructured props
    const {
        product,
        index,
        handleClick,
        fixedWidth = true,
        dynamicHeight = false,
        vendor = "DEFAULT"
    } = props;

    // Accessibility feature data
    const { highContrast } = useAppContext();

    // Retrieves the search bar action stuff
    const {
        handleCart,
        handleSearchBar
    } = useBehavioralContext();

    // Formats the product href without the .html suffix
    const formattedHref =
        product.href ? product.href.split(".html")[0] : "";

    // Checks if product has the special price attribute on it
    const hasSpecialPrice =
        product.specialPrice && product.specialPrice !== "" && product.specialPrice !== "0,00";

    const productPrice = vendor === "DEFAULT" ? product?.price : product?.tablePrice?.price;

    // An enum for all the icon types
    const serviceTypeIconEnum = {
        clinical_analysis: typeClinicalAnalysis,
        vaccine_combo: typeVaccineCombo,
        vaccine: typeVaccine
    }

    const installmentBlock = () => {
        const installment = product.installments;
        if (!installment || (Array.isArray(installment) && installment.length === 0)) {
            return null;
        }
        
        let installmentValue;

        if(vendor !== "DEFAULT") {
            installmentValue = product?.tablePrice?.installment?.label;
        } else {
            installmentValue = Array.isArray(installment)
            ? installment[installment.length - 1]?.label
            : installment?.label;   
        }
    
        if (!installmentValue) return null;
    
        return (
            <span
                className={`text-[13px] leading-none ${style.installmentRules} dark:text-white`}
                data-testid="product-card-installment"
            >
                {installmentValue}
            </span>
        );
    };

    return (
        <div
            className={`${style.productCard}`}
            data-testid={`product-link-${index}`}
        >
            <div className={`${style.triggerShadow} ${style.cardWrapper} dark:bg-[#464646] text-black dark:text-white ${fixedWidth ? style.fixedWidth : ""} ${!dynamicHeight ? "h-full" : ""}`}>
                {!!product.icon && (
                    <div
                        className={`select-none absolute top-0 left-0 flex justify-center items-center w-[30px] h-[30px] rounded-tl-lg rounded-br-lg ${style.icon}`}
                    >
                        <img
                            className={`w-[14px] dark:grayscale`}
                            src={serviceTypeIconEnum[product.icon]}
                            data-testid={`product-icon-${index}`}
                            alt={"Card icon"}
                        />
                    </div>
                )}
                {!!product.productLabel && (
                    <div
                        className={`select-none absolute top-0 right-0 flex justify-center items-center w-[120px] h-[20px] rounded-tr-lg rounded-bl-lg ${style[getServiceBadgeColor(product)]} dark:bg-contrast-yellow`}
                    >
                        <span className={`text-white dark:text-black font-semibold text-[10px] uppercase`}
                            data-testid={`product-badge-${index}`}>
                            {product.productLabel}
                        </span>
                    </div>
                )}
                <Link
                    href={`/${formattedHref}`}
                    onClick={() => {
                        handleSearchBar("isOpen", false);
                        handleClick(product);
                    }}
                    className={`${style.infoWrapper}`}
                >
                    <div className='flex justify-start'>
                        <p
                            className={`font-normal text-base leading-4`}
                            data-testid={`product-name-${index}`}
                        >
                            {product.name}
                        </p>
                    </div>
                </Link>
                <div className={"px-6 gap-x-3 w-full flex flex-row justify-between items-end"}>
                    <div className='flex justify-between'>
                        <div className='flex flex-col gap-y-1.5'>
                            <div className={`${style.specialPriceWrapper} ${hasSpecialPrice || vendor !== "DEFAULT" ? '' : 'hidden'}`}>
                                <div
                                    className={`${style.lineThrough} dark:border-b-contrast-yellow`}
                                    data-testid={`product-line-${index}`}
                                />
                                <p
                                    className={`${style.specialPrice} text-[#555] dark:text-white`}
                                    data-testid={`product-special-price-${index}`}
                                >
                                    {product.priceLabel} {product.price}
                                </p>
                            </div>

                            <p
                                className='text-base font-semibold leading-none'
                                data-testid={`product-price-${index}`}
                            >
                                {product.priceLabel} {hasSpecialPrice && vendor === "DEFAULT" ? product.specialPrice : productPrice}
                            </p>
                            
                            {product.installments && product.installments.length > 0 && !product?.installments[0]?.label.includes("vista") && (
                                <span
                                    className={`text-[13px] leading-4 ${style.installmentRules} dark:text-white`}
                                    data-testid="product-card-installment"
                                >
                                    {product.installments[product.installments.length - 1].label}
                                </span>
                            )}
                        </div>
                    </div>
                    <button
                        type={"button"}
                        className={`${style.cartButtonWrapper} ${highContrast ? "bg-contrast-yellow hover:bg-black" : "bg-[#02be83] hover:bg-[#146643]"}`}
                        onClick={() => {
                            handleSearchBar("isOpen", false);
                            handleCart("_", "_", {
                                isOpen:         true,
                                newProductData: {},
                                url:            `${formattedHref}`
                            })
                        }}
                    >
                        <img
                            src={iconCartV2}
                            alt={"Minicart button"}
                        />
                    </button>
                </div>
            </div>
        </div>
    )
}

export default ProductCardV2;
